import { RootState } from '../../store'

export const selectAutoSuggestValue = (state: RootState) => state.autosuggest
